// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__U0gTe flex_flex__woFO6 common_page__3ZnCt"};